import React, {MouseEvent, useEffect, useMemo, useState} from 'react';
import styles from './Presentations.module.scss';
import { Lesson as LessonType } from '@types';
import RightIcon from '@assets/icons/chewron_right.svg?react';
import Lesson from '../lesson/Lesson';
import { LastVisitedLessonContentFragment } from '@api/graphql-codegen';

type Props = {
  title: string;
  lessons: LessonType[];
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  isParentApp?: boolean;
};

function Presentations(props: Props) {
  const { title, lessons, lastVisitedLesson, isParentApp } = props;
  const [opened, setOpened] = useState(true);
  const [lessonList, setLessonList] = useState<Array<LessonType>>(lessons ?? [])
  useEffect(() => {
    const lessonList = [...lessons ?? []].sort((a,b) => (a?.number ?? 10000) - (b?.number ?? 0))
    setLessonList(lessonList as LessonType[]);
  }, [lessons])

  const handleToggle = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    const _opened = !opened;
    setOpened(_opened);
  };

  const wrapperClassName = useMemo(() => {
    const classes = [styles.wrapper];
    if (opened) {
      classes.push(styles.opened);
    }
    
    return classes.join(' ');
  }, [opened]);

  if (!lessonList) return null;

  return (
    <div className={wrapperClassName}>
      <div onClick={handleToggle} className={styles.header}>
        <RightIcon className={styles.rightIcon}/>
        <div className={styles.title}>{title}</div>
      </div>
      { opened && <>
        {lessonList.map((item: LessonType, index: number) => (
          <Lesson key={item.id} lesson={item} lastVisitedLesson={lastVisitedLesson} isParentApp={isParentApp}/>
        ))}
      </>
    } 
    </div>
  );
}

export default Presentations;
